<template>
    <v-layout wrap>
        <v-navigation-drawer absolute permanent right style="width: 600px;">
            <!--  상단 이미지 및 선택 타이틀 이름-->
            <v-list class="pa-1">
                <v-list-item>
                    <v-tabs v-if="copyValue._instanceInfo">
                        <v-tab>
                            <v-list-item-title>Instance Info</v-list-item-title>
                        </v-tab>
                        <v-tab>
                            <v-list-item-title>Actions</v-list-item-title>
                        </v-tab>
                    </v-tabs>
                    <v-tabs v-model="tab">
                        <v-tab v-for="tab in tabs" :key="tab" :id="tab.toLowerCase() + _uid">
                            <v-list-item-title>{{ tab }}</v-list-item-title>
                        </v-tab>
                    </v-tabs>
                    
                    <v-btn icon @click.native="closePanel()">
                        <v-icon color="grey lighten-1">mdi-close</v-icon>
                    </v-btn>
                </v-list-item>
            </v-list>

            <v-simple-table  v-if="copyValue._instanceInfo">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">Key</th>
                            <th class="text-left">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, index) in copyValue._instanceInfo" :key="index">
                            <td>{{ index }}</td>
                            <td>{{ copyValue._instanceInfo[index] }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>

            <v-list class="pt-0" dense flat>
                <v-divider></v-divider>
                <div v-if="tab == 0" style="margin-top: 10px">
                    <v-card flat>
                        <v-card-text>
                            <v-text-field
                                    v-if="tracingTag !== null"
                                    v-model="tracingTag"
                                    label="액티비티 ID*"
                                    counter="50"
                            ></v-text-field>
                            <v-text-field
                                    v-if="copyValue._type == 'org.uengine.kernel.bpmn.EndEvent' || copyValue._type == 'org.uengine.kernel.bpmn.TerminateEndEvent'"
                                    v-model="namePanel"
                                    label="End Status Name"
                                    autofocus
                            ></v-text-field>
                            <v-text-field
                                    v-else
                                    v-model="namePanel"
                                    label="액티비티 명"
                                    autofocus
                            ></v-text-field>
                            <v-switch
                                    v-if="copyValue._type == 'org.uengine.kernel.bpmn.EndEvent'"
                                    v-model="copyValue.stopAllTokens"
                                    label="Stops all running tokens"
                            ></v-switch>
                            <v-text-field
                                    v-model="copyValue.retryDelay"
                                    label="retryDelay"
                                    type="number"
                            ></v-text-field>
                        </v-card-text>
                    </v-card>
                </div>
                <div v-if="tab == 1">
                    <v-card flat>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="x"
                                            v-model="x"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="y"
                                            v-model="y"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="width"
                                            v-model="width"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="6" class="py-0">
                                    <v-text-field
                                            label="height"
                                            v-model="height"
                                            type="number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-text-field
                                    v-for="(item, idx) in style" :key="idx"
                                    v-model="style[idx].value"
                                    :label="item.key"
                            ></v-text-field>
                        </v-card-text>
                    </v-card>
                </div>
            </v-list>

        </v-navigation-drawer>
    </v-layout>
</template>

<script>
    import BpmnPropertyPanel from '../../BpmnPropertyPanel'

    export default {
        mixins: [BpmnPropertyPanel],
        name: 'bpmn-end-event-panel',
        props: {
        },
        data() {
            return {
                tabs: [ 'Properties', 'Visual' ],
                tab: null
            }
        },
        created: function () {
        },
        mounted: function () {
        },
        computed: {},
        watch: {},
        methods: {}
    }
</script>


<style lang="scss" rel="stylesheet/scss">

</style>

